// @ts-nocheck

import React, { useEffect, useState } from 'react'
import styles from './HotWatches.module.scss'
import CategoryProduct from '../CategoryProduct'
import Slider from 'react-slick'
import { useAppDispatch } from 'src/store/store'
import { useSelector } from 'react-redux'
import { fetchModalData } from 'src/store/slices/manageModalSlice'
import classNames from 'classnames'
import { fetchMobileModalData } from 'src/store/slices/mobileModalSlice'
import { fetchProductByCategory } from 'src/store/slices/fetchAllProduct'
import { useRouter } from 'next/router'
import Link from 'next/link'

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className={styles.nextArrowAlignment} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 6L15 12L9 18" stroke="#7A7E88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className={styles.prevArrowAlignment} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15 18L9 12L15 6" stroke="#7A7E88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}
export default function HotWatches() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  }

  const dispatch = useAppDispatch()
  const router = useRouter()
  const getAllState = useSelector((state: any) => state?.manageModalData?.data)
  const fetchMobileModal = useSelector((state: any) => state?.manageMobileModal?.data)
  const [hotWatchesData, setHotWatchesData] = useState([])

  useEffect(() => {
    fetchProduct()
  }, [])

  const handleClose = () => {
    router.push('/feed')
  }

  const fetchProduct = () => {
    dispatch(
      fetchProductByCategory({
        category: 'fashion-and-accessories',
        subCategory: router?.asPath?.includes('women') ? "women-accessories" : "men-accessories",
        childSubCategory: router?.asPath?.includes('women') ? 'sunglasses' : 'sunglasses',
        isShopifyProduct: false,
        page: 1,
        limit: 6,
      }),
    ).then((response) => {
      setHotWatchesData(response?.payload?.getAllProducts?.data)
    })
  }

  return (
    <div className={styles.hotWatchesSection}>
      <div className={styles.hotWatchesHeader}>
        <h4>Hot Watches</h4>
        {/* <div
          className={classNames(styles.seeMoreButton, styles.webview)}
          onClick={() => {
            dispatch(
              fetchModalData({
                ...getAllState,
                allModalData: [
                  ...getAllState?.allModalData,
                  { modal: 'categoryHotWatches', isOpen: true, id: { width: 70 }, modalFor: 'bigModal' },
                ],
                lastModalData: getAllState?.lastModalData,
              }),
            )
          }}
        >
          <a>See more</a>
        </div> */}

        <div
          className={classNames(styles.seeMoreButton, styles.mobileview)}
          onClick={() =>
            dispatch(
              fetchMobileModalData({
                allModalData: [
                  ...(fetchMobileModal?.allModalData ? fetchMobileModal?.allModalData : []),
                  { modal: 'mobileHotWatches', isOpen: true, id: 0, transform: 60 },
                ],
                lastModalData: fetchMobileModal?.lastModalData,
              }),
            )
          }
        >
          <a>See more</a>
        </div>
      </div>
      <div className={styles.hotWatchesDetailsBox}>
        <div className={styles.watchesSliderImg}>
          <Slider {...settings}>
            {[0, 1, 2, 3, 4, 5].map((_, index) => {
              return (
                <div
                  className={styles.hotWatchesBannerImg}
                  key={index}
                  onClick={() => {
                    router.push(`/`)
                  }}
                >
                  <img src="/assets/img/new-banner-img.png" alt="new banner" />
                </div>
              )
            })}
          </Slider>
        </div>
        <div className={styles.hotWatchesAllDetails}>
          <div className={styles.hotWatchesGrid}>
            {hotWatchesData?.map((item, index) => {
              return (
                <div className={styles.hotWatchesGridItem} key={`r${index}`}>
                  <CategoryProduct index={index} item={item} />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
